<template>
  <div
    class="layout--main"
    :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]"
    v-if="isAuthenticated"
  >
    <the-customizer
      v-if="!disableCustomizer"
      :footerType="footerType"
      :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop"
      @updateFooter="updateFooter"
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
    />
    <v-nav-menu
      :navMenuItems="filteredNavMenuItems"
      title="NGBSS"
      parent=".layout--main"
    />
    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="navMenuItems"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->
      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-solid border-grey-light':
                      $route.meta.breadcrumb,
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <!-- DROPDOWN -->
                <vs-dropdown
                  vs-trigger-click
                  class="ml-auto md:block hidden cursor-pointer"
                >
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/view/profile').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/todo').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/email').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>
              <vx-breadcrumb
                v-if="!$route.meta.hideBreadcrumb"
                class="ml-4 md:block hidden"
                :list="list"
              />

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";
import { mapState, mapGetters } from "vuex";
import { setBearerToken } from "../../http/index";
export default {
  components: {
    BackToTop,
    TheCustomizer,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    vxbreadcrumb: "vx-breadcrumb",
  },
  data() {
    return {
      logoutCalled: false,
      isLoggedIn: true,
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: navMenuItems,
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      disableCustomizer: themeConfig.disableCustomizer,
      permissions: null,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },
  computed: {
    ...mapGetters({ userType: "auth/userType" }),
    ...mapState({
      permissionList: (state) => state.auth.user,
    }),
    filteredNavMenuItems() {
      if (this.userType === "Super user") {
        return this.navMenuItems;
      } else {
        this.permissions = this.permissionList.permissions;

        const cloneMenuItems = (items) => {
          return items.map((item) => ({
            ...item,
            submenu: item.submenu ? cloneMenuItems(item.submenu) : undefined,
          }));
        };

        const filterMenu = (menuItems) => {
          return menuItems.filter((item) => {
            if (item.submenu) {
              item.submenu = filterMenu(item.submenu);
              return item.submenu.length > 0;
            } else {
              return this.permissions.includes(item.name);
            }
          });
        };

        return filterMenu(cloneMenuItems(this.navMenuItems));
      }
    },

    list() {
      let list = this.$route.matched.filter((route) => route.name || route.meta.label);
      list = list.map((el) => {
        if (el.path === "/") el.path = "";
        return el;
      });

      return list;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default") return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg";
        else return "content-area-full";
      } else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType === "hidden",
        "footer-sticky": this.footerType === "sticky",
        "footer-static": this.footerType === "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType === "hidden",
        "navbar-sticky": this.navbarType === "sticky",
        "navbar-static": this.navbarType === "static",
        "navbar-floating": this.navbarType === "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      return sessionStorage.getItem("ngb:user");
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff");
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    logoutUser() {
      if (this.logoutCalled) return;
      this.logoutCalled = true;
      this.isLoggedIn = false;
      this.$router.push("/login");
    },

    scheduleAccessTokenRefresh() {
      if (this.logoutCalled) return;

      const tokenData = JSON.parse(sessionStorage.getItem("tokenData"));
      if (!tokenData) return;
      const now = Date.now();
      const timeSinceIssue = now - tokenData.tokenIssuedAt;
      const accessTokenExpiryInMs =
        (tokenData.accessToken_Expiry - 60) * 1000 - timeSinceIssue;

      if (window.accessTokenTimeout) {
        clearTimeout(window.accessTokenTimeout);
      }
      window.accessTokenTimeout = setTimeout(() => {
        this.refreshAccessToken();
      }, accessTokenExpiryInMs);
    },

    scheduleRefreshTokenExpiry() {
      if (this.logoutCalled) {
        return;
      }
      const tokenData = JSON.parse(sessionStorage.getItem("tokenData"));
      const refreshTokenIssuedAt = sessionStorage.getItem("refreshTokenIssuedAt");
      if (!tokenData) {
        return;
      }
      const now = Date.now();
      const timeSinceIssue = now - refreshTokenIssuedAt;

      const refreshTokenExpiryInMs =
        tokenData.refreshToken_Expiry * 1000 - timeSinceIssue;

      if (window.refreshTokenTimeout) {
        clearTimeout(window.refreshTokenTimeout);
      }

      window.refreshTokenTimeout = setTimeout(() => {
        this.logoutUser();
      }, refreshTokenExpiryInMs);
    },
    async refreshAccessToken() {
      const tokenData = JSON.parse(sessionStorage.getItem("tokenData"));
      const now = Date.now();
      try {
        if (tokenData && tokenData.refreshToken) {
          const refreshToken = tokenData.refreshToken;
          const data = {
            refreshT: refreshToken,
          };
          const refreshData = await this.$store.dispatch("auth/refreshTokenAction", data);
          if (refreshData && refreshData.data) {
            const newTokenData = {
              refreshToken: refreshData.data.refreshToken,
              accessToken_Expiry: refreshData.data.accessToken_Expiry,
              refreshToken_Expiry: refreshData.data.refreshToken_Expiry,
              tokenIssuedAt: now,
            };

            sessionStorage.setItem("ngb:bearer_token", refreshData.data.accessToken);
            setBearerToken(refreshData.data.accessToken);
            sessionStorage.setItem("tokenData", JSON.stringify(newTokenData));

            this.scheduleAccessTokenRefresh();
          } else {
            //
          }
        } else {
          return;
        }
      } catch (e) {
        this.logoutUser();
      }
    },
  },
  beforeDestroy() {
    clearTimeout(window.accessTokenTimeout);
    clearTimeout(window.refreshTokenTimeout);
    window.accessTokenTimeout = null;
    window.refreshTokenTimeout = null;
  },
  created() {
    this.scheduleAccessTokenRefresh();
    this.scheduleRefreshTokenExpiry();
    const color =
      this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
  },
  beforeCreate() {
    if (!this.$store.getters["auth/isLogin"]) {
      this.$router.push("/login");
    }
  },
};
</script>
